/**
 * Group object array by property
 * Example, groupBy(array, ( x: Props ) => x.id );
 * @param array
 * @param property
 */
export const groupBy = (array: any[], property: string) => {
  var hash: { [key: string]: any[] } = {}
  for (var i = 0; i < array.length; i++) {
    if (!hash[array[i][property]]) hash[array[i][property]] = []
    hash[array[i][property]].push(array[i])
  }
  return hash
}

export default groupBy
